<template>
	<div class="detail-page" v-if="detail">
		<h2 class="title">{{detail.contentTitle}}</h2>
		<div class="datetime">{{detail.createdDt.substring(0,10)}}  发表</div>
		<div class="detail-ctn" v-html="detail.contentDesc">
			
		</div>
	</div>
</template>


<script>
export default {
	name: 'newsDetail',
	components:{
		
	},
	data () {
		return {
			detail:null
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		const { id } = this.$route.params
		this.getDetail(id)
	},
  
	methods:{
		
		//获取新闻详情
		getDetail(contentId){
			this.$axios({
				url:`/jxedu/api/site/findById/${contentId}`,
			}).then(res=>{
				let detail = res.data
				detail.createdDt = detail.createdDt.replace(/\//g,"-")
				this.detail = detail
			})
		},
		
	}
}
</script>

<style lang="less" scoped>
@vm: 7.5vw;
.detail-page{
	padding:40/@vm 32/@vm;
	.title{ font-size:40/@vm; line-height:56/@vm; font-weight: bold;  letter-spacing: 1px;}
	.datetime{ font-size:28/@vm; color:#666666; line-height:28/@vm; margin-top:20/@vm; }
	.detail-ctn{
		margin-top:52/@vm; font-size:28/@vm; line-height:44/@vm; color:#333;  letter-spacing: 1px;
		/deep/ img{ max-width:100%; }
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/news-detail/tpl-mobile.vue